import { isIe11 } from 'Utils/browserDetect'; //eslint-disable-line

const styleSheet = () => ({
  centerForm: {
    display: isIe11() ? 'table' : 'flex',
    width: '100%',
    minHeight: '100vh',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: isIe11() ? '820px' : 'inherit',
    margin: isIe11() ? '0 auto' : 'inherit',
  },
  centerForIE: {
    display: 'table-cell',
    verticalAlign: 'middle',
  },
});

export default styleSheet;
